import { createEffect } from "effector";
import { IChangePasswordRequest } from "./types";
import axios from "axios";
import { handleAxiosError } from "../../../shared/lib/error/handleAxiosError";


export const confirmChangePasswordFx = createEffect(async (body: IChangePasswordRequest) => {
	try {
		await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/password/reset-confirm`, body);
	}
	catch (error: unknown) {
		handleAxiosError(error);
	}
})
